import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ja';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import VueBootstrapToasts from 'vue-bootstrap-toasts'
import VueOnsen from 'vue-onsenui';
import axios from 'axios';
import VueAxios from 'vue-axios';
import 'onsenui/css/onsenui.css';
import App from './App';
import router from './router'
import store from './store';
import Toasted from 'vue-toasted';
import { sync } from 'vuex-router-sync';
import '@/permission';
import { Auth } from '@/utils/auth'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'

import VueSimpleContextMenu from 'vue-simple-context-menu'
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'

import 'onsenui/css/onsen-css-components.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import '../static/css/onsen-css-components-pink.min.css';

Vue.config.productionTip = false;

require('lodash')
Vue.use(BootstrapVue)
Vue.use(VueBootstrapToasts)
Vue.use(Element, { locale });
Vue.use(VueOnsen);
Vue.component('apexchart', VueApexCharts)
Vue.use(VueAxios, axios);
Vue.use(Toasted,  {
                    theme: "bubble",
                    position: "top-right",
                    duration : 5000
                  })

sync(store, router)
store.dispatch('Initialize')

Vue.component('vue-simple-context-menu', VueSimpleContextMenu)

Vue.mixin({
  data () {
    return {
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    }
  },
  methods: {
    goTo(routeName) {
      this.$router.push({ name: routeName });
      store.commit('toggleMenu', false);
    },
    goToRoute(url) {
      this.$router.push(url)
      store.commit('toggleMenu', false);
    },
    setProtectedTimeout(callback, timeoutInSec ) {
      if (this._isDestroyed ) {
        return null
      } else {
        return setTimeout(callback, timeoutInSec)
      }
    },
  }
})

new Vue({
  components: {
    App,
  },
  template: '<App/>',
  router,
  methods: {
    isAuthStillLogged () {
      Auth.login(this.getTokenFromParams())
      if (!Auth.isAuthed()) {
        let params = {redirect_uri: window.location.href,
          client_id: process.env.VUE_APP_AIO_CONNECT_CLIENT_ID,
          response_type: 'id_token',
          nonce: 'waluigithewinner'}
        window.location = process.env.VUE_APP_AIO_CONNECT_URL + "auth?"+ this.encodeDataToURL(params)
      }
      setTimeout(function () {
        this.isAuthStillLogged()
      }.bind(this), 10000)
    },
    getTokenFromParams () {
      const parsedParams = {}
      const parsedUrl = new URL(window.location.href)
      parsedUrl.hash.split('&')
        .map(part => part.replace(/#/, ''))
        .forEach(param => {
          const parts = param.split('=')
          parsedParams[parts[0]] = parts[1]
        })
      return parsedParams['id_token']
    },
    encodeDataToURL (data) {
      return Object
        .keys(data)
        .map(value => `${value}=${encodeURIComponent(data[value])}`)
        .join('&')
    }
  },
  mounted () {
    this.isAuthStillLogged()
  }
}).$mount('#app');


/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   template: '<App/>',
//   router,
//   components: { App },
// });



// WEBPACK FOOTER //
// ./src/main.js